import { render } from "./CategoryTreeImportAssistant.vue?vue&type=template&id=09c67d5e&scoped=true"
import script from "./CategoryTreeImportAssistant.vue?vue&type=script&lang=js"
export * from "./CategoryTreeImportAssistant.vue?vue&type=script&lang=js"

import "./CategoryTreeImportAssistant.vue?vue&type=style&index=0&id=09c67d5e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09c67d5e"]])

export default __exports__